import { CallInsightPanel } from '@frontend/call-insight-panel';
import { GlobalPanelEntry } from '@frontend/panel-engine';

export { VoicemailDetailsGlobalPanel } from '@frontend/calls-v2';

/**
 * ## GLOBAL PANEL REGISTRATION
 *
 * This file is used to register global panels that can be opened from anywhere in the app.
 * Simply export your global panel component here and it will be registered automatically.
 */

export const CallTakeawayGlobalPanel = () => (
  <GlobalPanelEntry id='call-insight' width='medium'>
    <CallInsightPanel />
  </GlobalPanelEntry>
);
